import { FC, useEffect, useState } from "react";
import SideInfo from "../../../pages/Platform/SideInfo";
import { useTabContext } from "../../../context/tabs/TabContext";
import BarChart from "../../charts/BarChart";
import { PeriodFilter } from "../../../common/enums/common.enums";
import { getTreasuryTotalMoneySpend } from "../../../api/clubs/club.api";
import { convertChartData } from "../../../common/helpers/chart.helper";
import { convertStatisticData } from "../../../common/helpers/statistics.helper";
import { IChart, IChartInfo } from "../../../common/interfaces/chart.interface";
import { IStatistics } from "../../../common/interfaces/statistic.interface";

const TotalMoneySpendChart: FC<{ clubAddress: string }> = ({ clubAddress }) => {
  const [chartTab, setChartTab] = useState<string>(PeriodFilter.DAILY);
  const [totalMoneySpendChartInfo, setTotalMoneySpendChartInfo] =
    useState<IChart[]>();
  const [
    totalMoneySpendChartInfoStatistics,
    setTotalMoneySpendChartInfoStatistics,
  ] = useState<IStatistics>();

  const changeChartTab = (tab: PeriodFilter): void => {
    setChartTab(tab);
  };

  useEffect(() => {
    void getTotalMoneySpendChartInfo();
  }, []);

  const getTotalMoneySpendChartInfo = async () => {
    try {
      const response: IChartInfo = await getTreasuryTotalMoneySpend(
        clubAddress
      );
      const convertedChartData: IChart[] | undefined = convertChartData(
        response,
        "Total money spend in Treasury"
      );
      setTotalMoneySpendChartInfo(convertedChartData);
      const statisticData = convertStatisticData(response);
      setTotalMoneySpendChartInfoStatistics(statisticData);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <useTabContext.Provider
      value={{
        tab: chartTab,
        changeTab: changeChartTab,
      }}
    >
      <SideInfo statisticsData={totalMoneySpendChartInfoStatistics} />
      <BarChart chartData={totalMoneySpendChartInfo} />
    </useTabContext.Provider>
  );
};

export default TotalMoneySpendChart;
